import { InjectionToken } from '@angular/core';
import { AlertsTokenProvider } from './types';

export const ALERTS_TOKEN_PROVIDER = new InjectionToken<AlertsTokenProvider>(
  '@ipreo/northstar-alerts Auth Token Provider'
);

export const MESSAGE_LOAD_LIMIT = 50;